import "babel-polyfill";
import "picturefill";

import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import Raven from "raven-js";
import ReactGA from "react-ga";
import { BrowserRouter as Router } from "react-router-dom";

import { Provider, } from "mobx-react";
import { injectGlobal, } from "emotion";

import App from "./routes";
import RootStore from "./store/rootStore";
import ContentsStore from "./store/ContentsStore";
import PortalStore from "./store/portalStore";
import "./styles/styles.scss";

// Initialize ReactGA for Google analytics
// see .env.* files for ID
ReactGA.initialize(process.env.REACT_APP_GA_UID);

/**
 * Initialize sentry for error tracking
 * Only install sentry and send errors when in beta or production
 */
if (
  window.location.hostname === "beta.beacon.co.tt" ||
  window.location.hostname === "beacon.co.tt"
) {
  Raven.config(
    "https://1b98cc573a9d456b852f67893a01baa4@sentry.io/1248331",
    {
      whitelistUrls: [
        `${window.location.hostname}/wp-content/themes/beacon/scg-templates/static/js`,
      ]
    }
  ).install();
}

injectGlobal({
  body: {
    background: "#fafafa !important",
    fontFamily: "Open Sans, sans-serif !important",
  },
});

ReactDOM.render(
  <Provider
    store={new RootStore()}
    contentsStore={new ContentsStore()}
    portalStore={new PortalStore()}
  >
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("beacon-quote-container")
);

Modal.setAppElement('#beacon-quote-container');


// WEBPACK FOOTER //
// ./src/index.js